<template>
  <v-list dense>
    <v-list-item-group
      v-model="indexOfSelectedLayer"
      @change="selectLayer"
    >
      <draggable
        v-model="computeLayers"
        :disabled="!creationAccess"
        @end="endDragLayer"
      >
        <template v-for="(layer, index) in computeLayers">
          <v-list-item
            v-if="layer != null"
            :key="index"
          >
            <v-list-item-icon>
              <v-icon>mdi-layers</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ layer }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </draggable>
    </v-list-item-group>
  </v-list>
</template>

<script>
// Components
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  props: {
    creationAccess: {
      type: Boolean,
      default: false,
    },
    layers: {
      type: Array,
      default: () => [],
    },
    layerSelected: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      tempLayers: [],
      currentLayer: undefined,
    };
  },
  computed: {
    computeLayers: {
      get() {
        return this.layers;
      },
      set(value) {
        this.tempLayers = value;
        this.$emit("update:layers", value);
      },
    },
    indexOfSelectedLayer: {
      get() {
        let index = parseInt(this.computeLayers.indexOf(this.layerSelected));
        if (index < 0) {
          return undefined;
        }
        return index;
      },
      set(value) {
        this.currentLayer = value;
      },
    },
    getLayerMoved() {
      return this.$store.state.creation.layerMoved;
    },
  },
  watch: {
    getLayerMoved: function () {
      if (this.getLayerMoved) {
        this.dragLayer(this.getLayerMoved);
      }
    },
  },
  mounted() {
    this.tempLayers = this.layers;
  },
  methods: {
    selectLayer(index) {
      let res = undefined;

      if (index !== undefined) {
        res = this.computeLayers[index];
      }

      this.$emit("select-layer", res);
    },
    endDragLayer() {
      this.$emit("layers-moved", this.computeLayers);
    },
    dragLayer(layer) {
      const pos = this.tempLayers.indexOf(layer.element);
      const tempo = this.tempLayers;
      let x = pos - 1;

      switch (layer.move) {
        case "top":
          tempo.splice(pos + 2, 0, tempo[pos]);
          delete tempo[pos];
          break;
        case "bottom":
          if (x < 0) {
            x = 0;
          }
          tempo.splice(x, 0, tempo[pos]);
          delete tempo[pos + 1];
          break;
        case "edit":
          tempo.splice(layer.pos, 0, tempo[pos]);
          delete tempo[pos + 1];
          break;

        default:
          break;
      }
      this.tempLayers = [];

      tempo.forEach((element) => {
        this.tempLayers.push(element);
      });

      this.computeLayers = this.tempLayers;
      this.$emit("layers-moved", this.computeLayers);

      this.$store.dispatch("layerMoved", null).creation;
    },
  },
};
</script>
